import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
  onUnmounted,
  ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfiniteScroll',
  emits: ["load"],
  setup(__props, { emit: __emit }) {

const sentinel = ref<HTMLDivElement | null>(null);
let observer: IntersectionObserver | null = null;

const emits = __emit;

function handleIntersect(entries: IntersectionObserverEntry[]): void {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      emits('load');
    }
  });
}

onMounted(() => {
  observer = new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });

  if (sentinel.value) {
    observer.observe(sentinel.value);
  }
});

onUnmounted(() => {
  if (sentinel.value && observer) {
    observer.unobserve(sentinel.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "top"),
    _createElementVNode("div", {
      ref_key: "sentinel",
      ref: sentinel
    }, null, 512),
    _renderSlot(_ctx.$slots, "bottom")
  ]))
}
}

})